export const formatMoney = (value: number): string => {
  const formattedValue: string = (value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedValue;
};

export const formatAgency = (agency: string): string => {
  if (agency.length >= 4)
    return agency.slice(-4);
  else
    return agency;
}

export const formatEffectType = (effectType: string): string => {
  let formattedEffect = "";
  switch (effectType) {
    case "1":
      formattedEffect = "Troca de titularidade";
      break;
    case "2":
      formattedEffect = "Ônus - Cessão fiduciária";
      break;
    case "3":
      formattedEffect = "Ônus - Outros";
      break;
    case "4":
      formattedEffect = "Bloqueio judicial";
      break;
    case "8":
      formattedEffect = "Promessa de Cessão";
      break;
  }
  return formattedEffect;
};

export const formatDivisionRule = (divisionRules: string): string =>{
  let divisao = divisionRules;
  if(divisao == "1")  divisao ="Comprometimento de valor definido.";
  else if(divisao == "2") divisao = "Comprometimento de percentual do valor que vier a ser constituído."
  return divisao;
}

